/* src/app/components/user/UserHeader/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { toUpper } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Avatar,
  CardHeader,
  Divider,
  IconButton,
  Typography,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import styles from './styles';

const avatar = (classes, caption, src, name) => (
  <div className={classes.avatarWrapper}>
    <Avatar aria-label="Avatar" src={src} className={classes.avatar}>
      {!src && toUpper(name[0])}
    </Avatar>
    {caption && <Typography>{caption}</Typography>}
  </div>
);

const UserHeader = ({ classes, caption, name, email, phone, onMoreActions, src }) => (
  <React.Fragment>
    <CardHeader
      avatar={avatar(classes, caption, src, name)}
      action={onMoreActions == null ? null : (
        <IconButton onClick={onMoreActions}><MoreVert /></IconButton>
      )}
      title={name}
      subheader={`${email} | ${phone}`}
    />
    <Divider />
  </React.Fragment>
);

UserHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  caption: PropTypes.string,
  onMoreActions: PropTypes.func,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string,
  src: PropTypes.string,
};

UserHeader.defaultProps = {
  phone: 'No Phone Number',
  caption: '',
  onMoreActions: null,
  src: '',
};

export default withStyles(styles)(UserHeader);



// WEBPACK FOOTER //
// ./src/app/components/user/UserHeader/index.js